'use strict';

import $ from 'jquery';

export default class FriendForm {
	constructor() {
		this.name = 'friend-form';

        const $spanCheckbox = $('.scfForm span:not(".scfCheckbox")');
        const $friendsForm = $('.scfForm .halfSection');
        const $friendsSection = $('.scfForm .friendsSection');

        let $checkFriendsForm = $friendsForm.find('input[type="checkbox"]');


        if($checkFriendsForm.prop("checked")) {
            $checkFriendsForm.addClass('active');
            $friendsSection.addClass('open');

        } else {
            $checkFriendsForm.removeClass('active');
            $friendsSection.removeClass('open');
        }

        $checkFriendsForm.on('click', function(e){
            if($checkFriendsForm.is(':checked')) {
                $friendsSection.addClass('open');
            } else {
                $friendsSection.removeClass('open');
            }
        });

        $spanCheckbox.each(function(index, value) {
            let $content = $(this);

            $content.on('click', () => {
                let $checkbox = $content.find('input[type="checkbox"]');
                $checkbox.prop('checked', !$checkbox.prop("checked"));
                $content.toggleClass('box-checked');
            });
        });
	}
}
